import { Box, Typography } from '@mui/material';
import { eventImageStyles } from './eventDetailsStyles';

const EventImage = ({ src, title }) => src ? (
  <Box component="img" src={src} alt={title} sx={eventImageStyles.image} />
) : (
  <Box sx={eventImageStyles.fallback}>
    <Typography sx={{ fontWeight: 700 }}>Sidra Medicine Event</Typography>
  </Box>
);

export default EventImage;
